import { useRef } from "react";

export default function useSwipe({

    onNext,
    onPrevious,
    threshold = 60,

}) {

    const startX = useRef(0);
    const startY = useRef(0);

    const onTouchStart = (e) => {

        const touch = e.touches[0];

        startX.current = touch.clientX;
        startY.current = touch.clientY;

    };

    const onTouchEnd = (e) => {

        const touch = e.changedTouches[0];

        const dx = touch.clientX - startX.current;
        const dy = touch.clientY - startY.current;

        // Ignore vertical scrolling
        if (Math.abs(dy) > Math.abs(dx))
            return;

        if (dx > threshold)
            onPrevious();

        if (dx < -threshold)
            onNext();

    };

    return {

        onTouchStart,

        onTouchEnd,

    };

}